import { createFileRoute } from '@tanstack/react-router';
import { DocumentPage, validateViewDocSearch } from '@/components/sales/document-page';

export const Route = createFileRoute('/sales/delivery-challans/$documentId')({
  component: View,
  validateSearch: validateViewDocSearch,
});

function View() {
  const { documentId } = Route.useParams();
  const { send } = Route.useSearch();
  return <DocumentPage kind="delivery_challan" id={documentId} openSend={send === '1'} />;
}
